import "core-js/modules/es.array.push.js";
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Modal } from 'tombac';
import { AddIcon } from 'tombac-icons';
import { AssignContractUsers } from "./AssignContractUsers";
import { ContractCreatedModal } from "./ContractCreatedModal";
import { ContractFormModal } from "./ContractFormModal";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ModalWithOverflow = styled(Modal).withConfig({
  displayName: "CreateContractButton__ModalWithOverflow"
})(["overflow:visible;.TombacModalWindow{overflow:visible;}"]);
export const CreateContractButton = _ref => {
  let {
    role,
    ...stylingProps
  } = _ref;
  const history = useHistory();
  const [step, setStep] = useState(null);
  const [contract, setContract] = useState();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => setStep('form'),
      prepend: /*#__PURE__*/_jsx(AddIcon, {}),
      type: "button",
      variant: "primary",
      ...stylingProps,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "CreateContractButton.tsx",
      "data-sentry-element": "Button",
      children: "New contract"
    }), /*#__PURE__*/_jsx(ContractFormModal, {
      isOpen: step === 'form',
      onCancel: () => setStep(null),
      onSaveSuccess: contract => {
        setContract(contract);
        setStep('confirmation');
      },
      "data-sentry-element": "ContractFormModal",
      "data-sentry-source-file": "CreateContractButton.tsx",
      "data-sentry-element": "ContractFormModal"
    }), /*#__PURE__*/_jsx(ContractCreatedModal, {
      isOpen: step === 'confirmation',
      onAssignUsersClick: () => {
        setStep('assign-users');
      },
      onCloseClick: () => setStep(null),
      onNewContractClick: () => {
        setStep('form');
      },
      onViewContractClick: () => {
        setStep(null);
        history.push(`/contracts/${contract.id}`);
      },
      "data-sentry-element": "ContractCreatedModal",
      "data-sentry-source-file": "CreateContractButton.tsx",
      "data-sentry-element": "ContractCreatedModal"
    }), /*#__PURE__*/_jsx(ModalWithOverflow, {
      isOpen: step === 'assign-users',
      "data-sentry-element": "ModalWithOverflow",
      "data-sentry-source-file": "CreateContractButton.tsx",
      "data-sentry-element": "ModalWithOverflow",
      children: /*#__PURE__*/_jsx(AssignContractUsers, {
        contract: contract,
        onAssignSuccess: () => setStep(null),
        onCancel: () => setStep(null),
        userRole: role,
        "data-sentry-element": "AssignContractUsers",
        "data-sentry-source-file": "CreateContractButton.tsx",
        "data-sentry-element": "AssignContractUsers"
      })
    })]
  });
};